<template>
    <div class="social-offer" :class="[
            clickable ? 'clickable' : 'head-offer',
            { hover: listVisibility }
        ]" @click="toggleList">
        <div class="social-offer__btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.62168 15.6818C8.62187 15.6818 10.2434 14.0603 10.2434 12.0602C10.2434 10.06 8.62187 8.43848 6.62168 8.43848C4.62148 8.43848 3 10.06 3 12.0602C3 14.0603 4.62148 15.6818 6.62168 15.6818Z" fill="#C9C9C9"/>
                <path d="M17.6773 9.24335C19.6775 9.24335 21.299 7.62187 21.299 5.62168C21.299 3.62148 19.6775 2 17.6773 2C15.6771 2 14.0557 3.62148 14.0557 5.62168C14.0557 7.62187 15.6771 9.24335 17.6773 9.24335Z" fill="#C9C9C9"/>
                <path d="M17.6773 22.0002C19.6775 22.0002 21.299 20.3787 21.299 18.3785C21.299 16.3783 19.6775 14.7568 17.6773 14.7568C15.6771 14.7568 14.0557 16.3783 14.0557 18.3785C14.0557 20.3787 15.6771 22.0002 17.6773 22.0002Z" fill="#C9C9C9"/>
                <path d="M6.13284 11.0944L7.11279 12.7773L18.1687 6.3398L17.1887 4.65682L6.13284 11.0944Z" fill="#C9C9C9"/>
                <path d="M6.13209 12.7793L17.188 19.2168L18.1679 17.5338L7.11204 11.0963L6.13209 12.7793Z" fill="#C9C9C9"/>
            </svg>
            <span v-if="clickable">{{ $t('Share') }}</span>
        </div>
        <div class="social-offer__wrap" :class="{active: listVisibility}">
            <div class="social-offer__tooltip js-social-share-block">
                <span v-for="(item, index) in socialItems" :key="index" :class="[ 
                    'social-offer__tooltip-link',
                    item.class,
                    { 'js-social-share-item': item.isJsSocialShareItem }
                    ]" :id="item.id" :data-sharer="item.sharer" :data-url="url" ref="socialShareItems" @click="handleShare(item)">
                    <img :src="item.src" :alt="item.alt" />
                    <!-- {{ item.title }} -->
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { renderAlertVue } from "/webpack-assets/vue/utils/common.js";

export default {
    props: {
        offerId: {
            type: Number,
            required: false,
        },
        sharer: {
            type: String,
            required: false,
        },
        clickable: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
        listVisibility: false,
        url: null,
        user: window.common.user || null,
        socialItems: [
            {
                src: '/img/to-bookmarks-btn/url.svg',
                title: this.$t('Copy Link'),
                id: 'url-link',
                sharer: 'url',
                class: 'js-copy-item',
                link: '',
                isJsSocialShareItem: true
            },
            {
                src: '/img/to-bookmarks-btn/telegram.svg',
                title: '',
                sharer: 'telegram',
                class: '',
                isJsSocialShareItem: true
            },
            {
                src: '/img/to-bookmarks-btn/twitter.svg',
                title: 'Twitter',
                sharer: 'twitter',
                class: '',
                isJsSocialShareItem: true
            },
            {
                src: '/img/to-bookmarks-btn/whatsup.svg',
                title: 'Whatsapp',
                sharer: 'whatsapp',
                class: '',
                isJsSocialShareItem: true
            },
            {
                src: '/img/to-bookmarks-btn/vk.svg',
                title: 'VK',
                sharer: 'vk',
                class: '',
                isJsSocialShareItem: true
            },
            {
                src: '/img/to-bookmarks-btn/facebook.svg',
                title: 'Facebook',
                sharer: 'facebook',
                class: '',
                isJsSocialShareItem: true
            },
            {
                src: '/img/to-bookmarks-btn/group.svg',
                title: this.$t('Odnoklassniki'),
                sharer: 'okru',
                class: 'last',
                isJsSocialShareItem: true
            }
        ],
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.sharerUrl()
            this.socialSharerLoad();
        });
    },
    methods: {
        sharerUrl() {
            let currentUrl = window.location.href;
            let url = `${currentUrl}?offer_id=${this.offerId}`;
            if (this.user) {
                url += `&referal=${this.user.username}`;
            }
            this.url = url;
        },
        socialSharerLoad() {
            const socialShareItems = this.$refs.socialShareItems;
            socialShareItems.forEach((item) => {
                let socialBlock = item.closest('.js-social-share-block');
                let customUrl = socialBlock.getAttribute('custom-data-url');

                const url = item.getAttribute('data-url');

                if (!url || url.length === 0) {
                    if (customUrl && customUrl.length) {
                        item.setAttribute('data-url', customUrl);
                    } else {
                        let url = window.location.href;
                        item.setAttribute('data-url', url);
                    }
                }
            });
        },
        toggleList() {
            if (this.clickable) {
                this.listVisibility = !this.listVisibility;
            }
        },
        closeList() {
            this.listVisibility = false;
        },
        openShareWindow(url) {
            window.open(
                url,
                '_blank',
                'noopener,noreferrer,width=800,height=600'
            );
        },
        handleShare(item) {
            const shareUrl = encodeURIComponent(this.url);

            switch (item.sharer) {
                case 'url':
                    this.copyToClipboard(this.url || window.location.href);
                    renderAlertVue(this.$t('Copied!'), 'success', 2000);
                    break;

                case 'telegram':
                    this.openShareWindow(`https://t.me/share/url?url=${shareUrl}`);
                    break;

                case 'twitter':
                    this.openShareWindow(`https://twitter.com/intent/tweet?url=${shareUrl}`);
                    break;

                case 'facebook':
                    this.openShareWindow(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`);
                    break;

                case 'whatsapp':
                    this.openShareWindow(`https://wa.me/?text=${shareUrl}`);
                    break;

                case 'vk':
                    this.openShareWindow(`https://vk.com/share.php?url=${shareUrl}`);
                    break;

                case 'okru':
                    this.openShareWindow(`https://connect.ok.ru/offer?url=${shareUrl}`);
                    break;

                default:
                    console.warn('Unknown sharer:', item.sharer);
                    break;
            }
        },
        copyToClipboard(url) {
            const tempTextarea = document.createElement('textarea');
            tempTextarea.value = url;
            document.body.appendChild(tempTextarea);
            tempTextarea.select();
            document.execCommand('copy');
            document.body.removeChild(tempTextarea);
        },
    }
};
</script>

<style scoped lang="scss">
    .social-offer{
        position: relative;
        &.hover,
        &:hover{
            .social-offer__tooltip{
                opacity: 1;
                pointer-events: all;
            }
            svg{
                path{
                    fill: #4E8AFF;
                }
            }
            &.clickable{
                .social-offer__btn{
                    background-color: #4E8AFF1A;
                    span{
                        color: #4E8AFF;
                    }
                }
            }
        }
        &.clickable{
            display: flex;
            align-items: center;
            flex-direction: column;
            .social-offer__btn{
                background-color: #fff;
                height: 55px;
                width: 100%;
                transition: 0.4s;
                padding: 10px 20px;
                display: flex;
                align-items: center;
                svg path{
                    fill: #9D9D9D;
                }
            }
            .social-offer__tooltip{
                padding: 12px 15px;
                display: flex;
                flex-wrap: wrap;
                gap: 15px;
                width: 100%;
                opacity: 1;
                pointer-events: all;
                position: relative;
                background-color: #F6F5FA;
                top: 0;
                border-radius: 0;
                box-shadow: none;
            }
            .social-offer__wrap{
                height: 0;
                transition: 0.4s;
                pointer-events: none;
                &.active{
                    height: 87px;
                    pointer-events: all;
                }
            }
            &:hover{
                svg{
                    path{
                        fill: #4E8AFF;
                    }
                }
            }
        }
        &__btn{
            display: flex;
            align-items: center;
            gap: 15px;
            svg{
                path{
                    transition: 0.4s;
                }
            }
            span{
                font-family: "Avenir-Next";
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: 0px;
                color: #9D9D9D;
                transition: 0.4s;
            }
        }
        &__tooltip{
            display: flex;
            background-color: #fff;
            border-radius: 12px;
            padding: 12px 15px;
            gap: 10px;
            align-items: center;
            opacity: 0;
            pointer-events: none;
            transition: 0.4s;
            position: absolute;
            right: 0;
            top: 29px;
            z-index: 10;
            box-shadow: 0px 0px 15px 0px #00000026;
            &::before{
                content: '';
                position: absolute;
                width: 100%;
                top: -20px;
                height: 20px;
                left: 0;
                background-color: transparent;
            }
            &-link{
                width: 24px;
                height: 24px;
                transition: 0.4s;
                cursor: pointer;
                &:hover{
                    opacity: 0.7;
                }
                img{
                    width: 100%;
                }
            }
        }
    }
</style>